
export const apiKey = '310a6b49-8b17-11ec-b95c-0242ac110002';
export const mainBin = 'c3fd89a9b063';